import { useEffect, useRef } from "react";

const useAutoRefresh = (callback: () => void, intervalTime = 5 * 60 * 1000) => {
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const callbackRef = useRef(callback);

    // Siempre mantener la versión más reciente del callback
    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    const startInterval = () => {
        if (!intervalRef.current) {
            intervalRef.current = setInterval(() => {
                callbackRef.current();
            }, intervalTime);
        }
    };

    const stopInterval = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    useEffect(() => {
        // const handleVisibilityChange = () => {
        //     if (!document.hidden) {
        //         startInterval();
        //     } else {
        //         stopInterval();
        //     }
        // };

        // const handleFocus = () => {
        //     if (!document.hidden && !intervalRef.current) {
        //         startInterval();
        //     }
        // };

        // const handleBlur = () => {
        //     stopInterval();
        // };

        // document.addEventListener("visibilitychange", handleVisibilityChange);
        // window.addEventListener("focus", handleFocus);
        // window.addEventListener("blur", handleBlur);

        startInterval(); // Iniciar cuando se monta el hook

        return () => {
            stopInterval();
            // document.removeEventListener("visibilitychange", handleVisibilityChange);
            // window.removeEventListener("focus", handleFocus);
            // window.removeEventListener("blur", handleBlur);
        };
    }, []);
};

export default useAutoRefresh;
